var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('hero-section'),_c('calculator-section',{attrs:{"content":_vm.calculator}}),_c('infos-process-section'),_c('scenario-section',{attrs:{"content":_vm.scenarios,"simulationContent":_vm.simulation}}),_c('questions-section'),(_vm.isVisible)?_c('agreements-dialog'):_vm._e(),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }